/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
// import PropTypes from 'prop-types';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import Grid from '@mui/material/Grid';
import { useStyles } from './styles';
import useWidgetTheme from '../../../commons/widgetTheme';
import getCommonUIStyles from '../../../commons/uiStyles';
import Logo from '../logo';

function Banner (props) {
    const {
        widget,
        widgetTheme,
    } = useWidgetTheme();

    const classes = useStyles({
        widget,
    });

    if (!widget) {
        return <React.Fragment />;
    }

    function renderBannerImage () {
        if (!widget.bannerURL) {
            return (<React.Fragment />);
        }
        return ( <img
            className={classes.bannerImage}
            alt="banner"
            src={widget.bannerURL}
        />); 
    }

    return (
        <React.Fragment>
            <Grid
                id="content"
                className={classNames([classes.bannerRoot])}
            >
                { renderBannerImage() }
            </Grid>
            <Logo
                widget={widget}
                commonUIStyles={getCommonUIStyles({
                    widget,
                    widgetTheme,
                })}
            />
            
        </React.Fragment>
    );
}

Banner.propTypes = {
    
};


export default observer(Banner);